module.exports = __webpack_public_path__ + "img/table.9d1716d2.png";